/**
 * İK / OPEX takip yardımcıları — yeni durum sözlüğüne delegasyon.
 */
export {
  RECORD_STATUS_LABELS as ODUL_STATUS_LABELS,
  STATUS_FILTER_OPTIONS,
  getRecordStatusLabel as getStatusLabel,
  matchesStatusFilter,
  formatIsoDate,
  formatIsoDateTime,
  calcSlaDelay,
  BOARD_DECISION_LABELS,
  isClosedStatus,
} from './odulOneriStatus'

export { getManagerDecisionLabel, MANAGER_DECISION_LABELS } from './odulOneriManagerReasons'

export const getAssigneeLabel = (record) => {
  if (record?.assignee?.name) return record.assignee.name
  if (record?.assignee?.type === 'opex') return 'OPEX'
  if (record?.assignee?.type === 'manager') return record.assignee.name || 'Bölüm Yöneticisi'
  if (record?.assignee?.type === 'leader') return record.assignee.name || 'Uygulama Lideri'
  if (record?.assignee?.type === 'board') return 'Öneri Kurulu'
  if (record?.assignee?.type === 'ik') return 'İnsan ve Kültür'
  return '—'
}

export const getBoardDecisionLabel = (decision) => {
  if (!decision?.result) return '—'
  const map = {
    award: 'Ödül',
    thanks: 'Teşekkür',
    deferred: 'Erteleme',
  }
  return map[decision.result] || decision.result
}
